import { render } from "./rep050.vue?vue&type=template&id=3ae8eddc"
import script from "./rep050.vue?vue&type=script&lang=js"
export * from "./rep050.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__